<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            You Can Only Message Yourself on a Trial Account
        </template>

        <template #content>
            <div>
                While on your TextSpot trial, you can only only test functionality by sending messages to yourself.
            </div>
            <div class="mb-2 mt-2">
            
                During your trial you can only send messages to the number you signed up with (<span class="font-bold">{{ formattedNumber }}</span>). <br /><br />

                We know this is frustrating, but carriers require this to protect against spam. <br /><br />
            
                Once you upgrade we'll get you registered with carriers so you can send messages to your contacts. <br /><br />
            </div>
        </template>

        <template #footer>
            <a href='#' class="whitespace-nowrap mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" 
                v-on:click="$emit('close')" 
            >
                Okay, Got It
            </a>
    
            <Link :href="route('subscriptions.index')" @click="$emit('close')" class="w-full text-center">
                <jet-secondary-button class="">
                    VIEW PLANS & UPGRADE
                </jet-secondary-button>
            </Link>

        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'TrialOnlyMessageYourselfModal',
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },
    computed: {
        formattedNumber() {
            let phoneNumber = this.$page.props.auth.user.organization.phone; 
            //remove the +1 from the number..
            phoneNumber = phoneNumber.replace('+1', '');


            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
    }

}
</script>